import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Navbar from './navbar';
import Footer from './footer';
import { useLocation } from 'react-router-dom';


const Layout = ({ children }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <Box component="main" sx={{ flexGrow: 1 }}>
                {children}
            </Box>
            <Footer />
        </Box>
    );
};

export default Layout;